export const BASE_URL = process.env.REACT_APP_API_URL;
export const PROJECT_NAME = 'KIARA';
